// ─── Enums ──────────────────────────────────────────────────────────────────
export var EnumPaymentFrequencyType;
(function (EnumPaymentFrequencyType) {
    EnumPaymentFrequencyType["one_time_fee"] = "form.paymentFrequency.one_time_fee";
    EnumPaymentFrequencyType["mothly_fee"] = "form.paymentFrequency.mothly_fee";
    EnumPaymentFrequencyType["yearly_fee"] = "form.paymentFrequency.yearly_fee";
    EnumPaymentFrequencyType["weekly_fee"] = "form.paymentFrequency.weekly_fee";
    EnumPaymentFrequencyType["no_fee"] = "form.paymentFrequency.no_fee";
})(EnumPaymentFrequencyType || (EnumPaymentFrequencyType = {}));
export var EnumMonthType;
(function (EnumMonthType) {
    EnumMonthType["january"] = "form.month.january";
    EnumMonthType["february"] = "form.month.february";
    EnumMonthType["march"] = "form.month.march";
    EnumMonthType["april"] = "form.month.april";
    EnumMonthType["may"] = "form.month.may";
    EnumMonthType["june"] = "form.month.june";
    EnumMonthType["july"] = "form.month.july";
    EnumMonthType["august"] = "form.month.august";
    EnumMonthType["september"] = "form.month.september";
    EnumMonthType["october"] = "form.month.october";
    EnumMonthType["november"] = "form.month.november";
    EnumMonthType["december"] = "form.month.december";
})(EnumMonthType || (EnumMonthType = {}));
export var EnumServiceType;
(function (EnumServiceType) {
    EnumServiceType["pony"] = "form.service.pony";
    EnumServiceType["horse"] = "form.service.horse";
    EnumServiceType["owner"] = "form.service.owner";
    EnumServiceType["other"] = "form.service.other";
})(EnumServiceType || (EnumServiceType = {}));
//# sourceMappingURL=service.js.map